import React, { useState } from "react";
import styled from "styled-components";
import { motion, AnimatePresence } from "framer-motion";

// --- FAQ Data ---
const FAQ_DATA = [
  {
    question: "Wie lange halten die Wimpernextensions?",
    answer:
      "Ein Set hält in der Regel 3 bis 4 Wochen, bevor ein Auffülltermin empfohlen wird. Dies hängt von deinem natürlichen Wimpernzyklus und der richtigen Pflege ab.",
  },
  {
    question: "Ist die Behandlung schmerzhaft?",
    answer:
      "Absolut nicht! Die meisten unserer Kunden finden die Behandlung so entspannend, dass sie dabei einschlafen. Wir arbeiten mit höchster Präzision und Sanftheit.",
  },
  {
    question: "Was muss ich vor meinem PMU Termin beachten?",
    answer:
      "Bitte verzichte 24 Stunden vor der Behandlung auf Alkohol, Koffein und blutverdünnende Medikamente. So erzielen wir das beste Farbergebnis für deine Powderbrows.",
  },
  {
    question: "Kann ich mit den Extensions Sport machen?",
    answer:
      "Ja! Nach einer kurzen Aushärtungszeit von 24-48 Stunden sind deine Wimpern wasserfest. Wir empfehlen jedoch, Schweiß nach dem Sport vorsichtig mit einem speziellen Wimpernshampoo abzuwaschen.",
  },
];

// --- Styled Components ---

const FAQSection = styled.section`
  padding: 150px 20px;
  background-color: #f4efed; // Keeping the soft cream from the About section
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 80px;
`;

const Title = styled(motion.h2)`
  font-family: "Lovelace", serif;
  font-style: italic;
  font-size: clamp(2.5rem, 5vw, 4rem);
  color: #644747;
  margin-bottom: 10px;
`;

const AccordionWrapper = styled.div`
  width: 100%;
  max-width: 800px;
`;

const AccordionItem = styled.div`
  border-bottom: 1px solid rgba(163, 141, 146, 0.3);
`;

const QuestionButton = styled.button`
  width: 100%;
  padding: 30px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;
  text-align: left;

  span {
    font-size: 1.4rem;
    color: #1a1a1a;
    transition: color 0.3s ease;
  }

  &:hover span {
    color: #a38d92;
  }
`;

const Icon = styled(motion.div)`
  font-size: 1.5rem;
  color: #a38d92;
`;

const AnswerContent = styled(motion.div)`
  overflow: hidden;
  font-size: 1.05rem;
  line-height: 1.8;
  color: #4a3a3d;
`;

const AnswerInner = styled.div`
  padding-bottom: 30px;
`;

// --- Component ---

const FAQ = () => {
  const [expanded, setExpanded] = useState(null);

  return (
    <FAQSection>
      <Header>
        <Title
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          Häufig gestellte Fragen
        </Title>
      </Header>

      <AccordionWrapper>
        {FAQ_DATA.map((item, i) => (
          <AccordionItem key={i}>
            <QuestionButton
              onClick={() => setExpanded(expanded === i ? null : i)}
            >
              <span>{item.question}</span>
              <Icon animate={{ rotate: expanded === i ? 45 : 0 }}>+</Icon>
            </QuestionButton>

            <AnimatePresence initial={false}>
              {expanded === i && (
                <AnswerContent
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
                >
                  <AnswerInner>{item.answer}</AnswerInner>
                </AnswerContent>
              )}
            </AnimatePresence>
          </AccordionItem>
        ))}
      </AccordionWrapper>
    </FAQSection>
  );
};

export default FAQ;
